import React from 'react'
import { withTranslation } from 'react-i18next'
import withStyles from 'react-jss'
import compose from '@shopify/react-compose'

import { Button, FormError } from '@portal/kit/pkg/components'

import mseStyles from './mse-button-style'

const MseButton = ({ classes, external_error_code, t }) => (
  <>
    {external_error_code && <FormError message={t(`login.${external_error_code}_error`)} />}
    <div className={classes.loginMse}>
      <p className={classes.loginMseTitle} dangerouslySetInnerHTML={{ __html: t('login.mse_title') }} />
      <Button href="/api/mse/connect">{t('login.connect_mse')}</Button>
    </div>
  </>
)

export default compose(
  withStyles(mseStyles),
  withTranslation()
)(MseButton)
